import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../../../images/logo_remove_background.png'

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const isHomeRoute = location.pathname === '/';

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <nav className={`navbar ${isHomeRoute ? 'navbar--home' : ''}`}>
            <div className="nav-container">
                <Link to="/" className="nav-logo" onClick={closeMenu}>
                    <img src={logo} alt="takumi" width="100" height="100" />
                </Link>

                <div className={`nav-menu ${isOpen ? 'active' : ''}`}>
                    <Link
                        to="/"
                        className={`nav-link ${isActive('/') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        Home
                    </Link>
                    <Link
                        to="/services"
                        className={`nav-link ${isActive('/services') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        Services
                    </Link>
                    <Link
                        to="/products"
                        className={`nav-link ${isActive('/products') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        Products
                    </Link>
                    <Link
                        to="/about"
                        className={`nav-link ${isActive('/about') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        About
                    </Link>
                    <Link
                        to="/contact"
                        className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        Contact Us
                    </Link>
                    <Link
                        to="/events"
                        className={`nav-link ${isActive('/events') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        Events
                    </Link>
                    <Link
                        to="/status-track"
                        className={`nav-link ${isActive('/status-track') ? 'active' : ''}`}
                        onClick={closeMenu}
                    >
                        Status Track
                    </Link>
                </div>

                <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
